import { useDialogStore } from '@/stores/dialog'
import { useUserStore } from '@common/stores/userStore'
import { HttpClient } from '@/http/httpClient'
import { useDailyFrequency } from '@common/hooks/useDailyFrequency'
import { initGuideData } from '@/components/GuideLayer/mixins'
const http = new HttpClient()
const shouldShowIncentiveDialog = (name?: string) => {
  return true
}
export const useFetchDialogData = (router: any) => {
  const dialogStore = useDialogStore()
  const { isEarlyThanToday } = useDailyFrequency()
  function fetchDialogData(routerName: string) {
    const incentiveDialogUrl = '/aigc/api/activity/popup'
    if (routerName === 'home') {
      dialogStore.fetchDialogData({
        needSplash: true,
        incentiveDialogUrl,
        shouldShowSplash(isHigherPriority?: boolean) {
          let time = ''
          if (isHigherPriority) {
            time = localStorage.getItem('high_priority_splash_screen') ?? ''
          } else {
            // 创作引导进行中
            const { guideStep } = initGuideData('home')
            if (guideStep.value.length > 0 && guideStep.value[0] < 5) {
              return false
            }
            // 今天展示过开屏弹窗
            time = localStorage.getItem('splashScreen') ?? ''
            if (!time) {
              // 今天展示过创作引导
              const guideData = JSON.parse(localStorage.getItem('guide') ?? '{}')
              time = guideData.home?.[0].time ?? ''
            }
          }
          return isEarlyThanToday(time)
        }
      })
    } else {
      // 支持黑白名单控制
      if (shouldShowIncentiveDialog(routerName as string)) {
        dialogStore.fetchDialogData({
          incentiveDialogUrl
        })
      }
    }
  }
  router.afterEach(async (to: any) => {
    fetchDialogData(to.name as string)
  })
  // 刷新的时候，有时候会走这里，有时候不会走
  if (router.currentRoute.value.name) {
    fetchDialogData(router.currentRoute.value.name as string)
  }
  return {
    fetchDialogData
  }
}
